
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die Anthropologen Charlie Nunn und David Samson von der Duke University sammelten physiologische Daten von 29 Affenarten die alle im Zoo lebten und sich dort sogar ihre Hirnströme mit Elektroden messen liessen. Aus all dem entwickelten die Forscher dann ein Modell, mit dem sie bei den meisten Arten recht genau die Schlafdauer voraussagen konnten – nur beim Menschen nicht: `}<M mdxType="M">{`Würde er sich wie ein normaler Primat verhalten, müsste er dem Modell zufolge 9,5 Stunden pro Nacht schlafen.`}</M>{` Tatsächlich sind es sechs bis acht Stunden. Schläft der Mensch gegen seine Natur?  `}<br /><br />{`
So einfach ist es nicht. Denn der Mensch hat nicht nur die Dauer seines Schlafes verändert, sondern auch dessen Qualität. Er hat den Anteil des sogenannten REM-Schlafes auf Kosten des Non-REM-Schlafes gesteigert. Menschen verbringen rund 25 Prozent ihrer Schlafenszeit in dieser Phase des besonders lebhaften Träumens, nicht-menschliche Primaten eher um die fünf Prozent. `}<br /></p>
    <M mdxType="M">«Es sieht so aus, als ob wir den Schlaf optimiert haben»</M>, sagt Nunn. Was genau die längeren REM-Phasen bedeuten, ist Gegenstand von Spekulation. Entscheidend sei, dass sich der Schlafbedarf des Menschen offenbar reduziert hat, weil er sich in der gewonnenen Zeit anderen Dingen zuwenden konnte, die ihm einen adaptiven Vorteil brachten: dem Bau von Werkzeugen und Waffen, dem Unterrichten von Kindern, der Erfindung der Landwirtschaft.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;